<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title> STRANGE FIRE </title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ct3" id="p0007-01-0"><a id="pagevii">C<span class="small">ONTENTS</span> </a></p><a id="pagevii">
<p class="ser1"><img alt="978140020518_0007_002.jpg" class="maxwidth" src="images/978140020518_0007_002.jpg"/></p>
</a><p class="cct"><a id="pagevii"></a><a href="#/chapter3#tt3" id="ii3"><i>Introduction: For the Sake of His Name</i></a></p>
<p class="cct2"><a href="#/chapter4#tt4" id="ii4">Part 1: Confronting a Counterfeit Revival </a></p>
<p class="cct1"><a href="#/chapter5#tt5" id="ii5">1. Mocking the Spirit </a></p>
<p class="cct1"><a href="#/chapter6#tt6" id="ii6">2. A New Work of the Spirit? </a></p>
<p class="cct1"><span href="#/chapter7#tt7" id="ii7" title="Link target outside of Sample">3. Testing the Spirits (Part 1) </span></p>
<p class="cct1"><span href="#/chapter8#tt8" id="ii8" title="Link target outside of Sample">4. Testing the Spirits (Part 2) </span></p>
<p class="cct2"><span href="#/chapter9#tt9" id="ii9" title="Link target outside of Sample">Part 2: Exposing the Counterfeit Gifts </span></p>
<p class="cct1"><span href="#/chapter10#tt10" id="ii10" title="Link target outside of Sample">5. Apostles Among Us? </span></p>
<p class="cct1"><span href="#/chapter11#tt11" id="ii11" title="Link target outside of Sample">6. The Folly of Fallible Prophets </span></p>
<p class="cct1"><span href="#/chapter12#tt12" id="ii12" title="Link target outside of Sample">7. Twisting Tongues </span></p>
<p class="cct1"><span href="#/chapter13#tt13" id="ii13" title="Link target outside of Sample">8. Fake Healings and False Hopes </span></p>
<p class="cct2"><span href="#/chapter14#tt14" id="ii14" title="Link target outside of Sample">Part 3: Rediscovering the Spirit’s True Work </span></p>
<p class="cct1"><span href="#/chapter15#tt15" id="ii15" title="Link target outside of Sample">9. The Holy Spirit and Salvation </span></p>
<p class="cct1a"><span href="#/chapter16#tt16" id="ii16" title="Link target outside of Sample">10. The Spirit and Sanctification </span></p>
<p class="cct1a"><span href="#/chapter17#tt17" id="ii17" title="Link target outside of Sample">11. The Spirit and the Scriptures </span></p>
<p class="cct1a"><span href="#/chapter18#tt18" id="ii18" title="Link target outside of Sample">12. An Open Letter to My Continuationist Friends </span></p>
<p class="cct"><a id="pageviii"></a><span href="#/chapter19#tt19" id="ii19" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="cct"><span href="#/chapter20#tt20" id="ii20" title="Link target outside of Sample"><i>Appendix: Voices from Church History</i></span></p>
<p class="cct"><span href="#/chapter21#tt21" id="ii21" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="cct"><span href="#/index1#ttindex1" id="iiindex1" title="Link target outside of Sample"><i>Index</i></span></p>
<p class="cct"><span href="#/index2#ttindex2" id="iiindex2" title="Link target outside of Sample"><i>Scripture Index</i></span></p>
<p class="cct"><span href="#/chapter22#tt22" id="ii22" title="Link target outside of Sample"><i>About the Author</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?1abfb519